import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedCurrency from 'I18n/components/FormattedCurrency';

const PriceDisplay = (_ref) => {
  let {
    className,
    currencyCode,
    price,
    dataSelenium = '',
    round = true
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "currencyCode", "price", "dataSelenium", "round"]);

  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className,
    "data-selenium-id": dataSelenium
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedCurrency, {
      simplifyCurrency: true,
      value: round ? Math.ceil(price) : price,
      currencyCode: currencyCode
    })
  }));
};

export default PriceDisplay;